<template>
  <div id="contact-us"
    class="ekit-template-content-markup ekit-template-content-footer ekit-template-content-theme-support">
    <div data-elementor-type="wp-post" data-elementor-id="1647" class="elementor elementor-1647"
      data-elementor-settings="[]">
      <div class="elementor-section-wrap">
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-bd421f9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="bd421f9" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-afa7e99"
              data-id="afa7e99" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-1c7b320 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="1c7b320" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-de28084"
                      data-id="de28084" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-bc27efb elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="bc27efb" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container" style="cursor: pointer;"><img
                              style="height: 40px !important; vertical-align: middle;" src="/img/logo.png"> <span
                              style="color: white; font-size: 32px; font-weight: 400; letter-spacing: 2px; vertical-align: middle; text-shadow: rgb(255, 43, 43) 3px 0px 0px;">Cyber</span><span
                              style="color: white; font-size: 32px; font-weight: 400; letter-spacing: 2px; vertical-align: middle; animation: 1.5s linear 0s infinite normal none running animate;">Z</span>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-27151a8 elementor-widget elementor-widget-text-editor"
                          data-id="27151a8" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('footer.name')}}
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-c98014a e-grid-align-mobile-center e-grid-align-left elementor-shape-rounded elementor-grid-0 elementor-widget elementor-widget-social-icons"
                          data-id="c98014a" data-element_type="widget" data-widget_type="social-icons.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-social-icons-wrapper elementor-grid">
                              <span class="elementor-grid-item"> <a href="https://facebook.com/CyberZ.vn.sol"
                                  class="elementor-icon elementor-social-icon elementor-social-icon-facebook-square elementor-animation-float elementor-repeater-item-c218504"
                                  target="_blank"> <span class="elementor-screen-only">Facebook-square</span> <i
                                    class="fab fa-facebook-square"></i> </a> </span>

                              <span class="elementor-grid-item">
                                <a href="https://github.com/CyberZ-vn"
                                  class="elementor-icon elementor-social-icon elementor-social-icon-github-square elementor-animation-float elementor-repeater-item-d4fdd66"
                                  target="_blank"> <span class="elementor-screen-only">Github-square</span> <i
                                    class="fab fa-github-square"></i> </a> </span>

                              <span class="elementor-grid-item">
                                <a href="https://www.linkedin.com/company/cyberz-vn"
                                  class="elementor-icon elementor-social-icon elementor-social-icon-linkedin elementor-animation-float elementor-repeater-item-82e8f72"
                                  target="_blank"> <span class="elementor-screen-only">Linkedin</span> <i
                                    class="fab fa-linkedin"></i> </a> </span>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div
                      class="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-2951072 elementor-hidden-tablet elementor-hidden-mobile"
                      data-id="2951072" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-c1f3682 elementor-widget elementor-widget-heading"
                          data-id="c1f3682" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h5 class="elementor-heading-title elementor-size-default">Services</h5>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-008debd elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="008debd" data-element_type="widget" data-widget_type="icon-list.default">
                          <div class="elementor-widget-container">
                            <ul class="elementor-icon-list-items">
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Threat Hunter</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Incident Responder</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Secure Managed IT</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Compliance</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Cyber Security</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Disaster Planning</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <!-- <div
                      class="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-595ac05 elementor-hidden-mobile"
                      data-id="595ac05" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-9b537cd elementor-widget elementor-widget-heading"
                          data-id="9b537cd" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h5 class="elementor-heading-title elementor-size-default">Support</h5>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-0ab79f9 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="0ab79f9" data-element_type="widget" data-widget_type="icon-list.default">
                          <div class="elementor-widget-container">
                            <ul class="elementor-icon-list-items">
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Support</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Contact Us</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Knowledge Base</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">About Us</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">FAQ</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-icon"> <i
                                    aria-hidden="true" class="fas fa-caret-right"></i> </span> <span
                                  class="elementor-icon-list-text">Partnerships</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <div style="margin-right: 0;
                    margin-left: auto;"
                      class="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-ec5520b"
                      data-id="ec5520b" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-5712c26 elementor-widget elementor-widget-heading"
                          data-id="5712c26" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h5 class="elementor-heading-title elementor-size-default">{{$t('footer.contact')}}</h5>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-d27266d elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="d27266d" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h6 class="elementor-heading-title elementor-size-default">Email:</h6>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-6a57d3d elementor-widget__width-auto elementor-widget elementor-widget-text-editor"
                          data-id="6a57d3d" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> <a
                              href="mailto:support@cyberz.vn">support@cyberz.vn</a> </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-a35cbe3 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="a35cbe3" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h6 class="elementor-heading-title elementor-size-default">{{$t('footer.phone')}}:</h6>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-58056d2 elementor-widget__width-auto elementor-widget elementor-widget-text-editor"
                          data-id="58056d2" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> <a
                              :href="`tel:`+$t('footer.phone_desc').replace(/\s/g,'')">{{$t('footer.phone_desc')}}</a></div>
                        </div>
                        <br>
                        <!-- <div
                          class="elementor-element elementor-element-13cbdbd elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="13cbdbd" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h6 class="elementor-heading-title elementor-size-default">Fax:</h6>
                          </div>
                        </div> -->
                        <!-- <div
                          class="elementor-element elementor-element-e2917d5 elementor-widget__width-auto elementor-widget elementor-widget-text-editor"
                          data-id="e2917d5" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> +1 ( 987 ) 654 321 9 9</div>
                        </div> -->
                        <div style="width: 100%;"
                          class="elementor-element elementor-element-7bc56f1 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="7bc56f1" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h6 class="elementor-heading-title elementor-size-default">{{$t('footer.address')}}:</h6>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-dad2908 elementor-widget__width-auto elementor-widget elementor-widget-text-editor"
                          data-id="dad2908" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('footer.address_desc')}}</div>
                        </div>

                      </div>
                    </div>
                  </div>
                </section>
                <div
                  class="elementor-element elementor-element-6f68099 elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                  data-id="6f68099" data-element_type="widget" data-widget_type="divider.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-divider"> <span class="elementor-divider-separator"> </span></div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-0b140bc elementor-widget elementor-widget-text-editor"
                  data-id="0b140bc" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> Copyright &copy;{{(new Date()).getFullYear()}} CyberZ.vn. All
                    Rights Reserved</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FooterComponent',
  }
</script>